module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePage_CN_Euro_Mobile.f61a54e8.webp";